import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';
import { db } from './firebase';
import type { Vehicle, VehicleDraft } from '@/types/Vehicle';

function vehiclesCollection(uid: string) {
  return collection(db, 'users', uid, 'vehicles');
}

export function newVehicleId(): string {
  const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  for (let i = 0; i < 20; i++) {
    id += alpha[Math.floor(Math.random() * alpha.length)];
  }
  return id;
}

export async function listVehicles(uid: string): Promise<Vehicle[]> {
  const snap = await getDocs(query(vehiclesCollection(uid), orderBy('updatedAt', 'desc')));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() } as Vehicle));
}

export async function saveVehicle(uid: string, draft: VehicleDraft): Promise<string> {
  const ref = doc(vehiclesCollection(uid), draft.id);
  await setDoc(
    ref,
    {
      ...draft,
      updatedAt: serverTimestamp(),
      // Preserve createdAt on update; merge below means we only write
      // it on first save. We pre-write the field; merge keeps existing.
      createdAt: serverTimestamp(),
    },
    { merge: true }
  );
  return draft.id;
}

export async function deleteVehicle(uid: string, id: string): Promise<void> {
  await deleteDoc(doc(vehiclesCollection(uid), id));
}
